import { formatMoney } from '@staccx/bento'
import { formatDate } from '../../../V3/helpers/formatDate'

export function tollPassings() {
  return [
    {
      accessorKey: 'date',
      id: 'date',
      header: () => <span>Dato</span>,
      cell: ({ row }) => {
        const date = formatDate(row.original.date)
        return date ?? 'Ukjent'
      },
      meta: { alignmentType: 'date' },
    },
    {
      accessorKey: 'station',
      id: 'station',
      header: () => <span>Sted</span>,
      cell: ({ row }) => {
        const station = row.original.station
        return station ?? 'Ukjent'
      },
      meta: { alignmentType: 'string' },
    },
    {
      accessorKey: 'operator',
      id: 'operator',
      header: () => <span>Operatør</span>,
      cell: ({ row }) => {
        const operator = row.original.operator
        return operator ?? 'Ukjent'
      },
      meta: { alignmentType: 'string' },
    },
    {
      accessorKey: 'price',
      id: 'price',
      header: () => <span>Pris</span>,
      cell: ({ row }) => {
        const amount = formatMoney(row.original.price)
        return amount ? `${amount}NOK` : 'Ukjent'
      },
      meta: { alignmentType: 'string' },
    },
  ]
}
